/**
 * @generated SignedSource<<559de46e38a14a910355a8ee47e1050d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespRecentSales_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRecentSales_user">;
  readonly " $fragmentType": "PdpRespRecentSales_user";
};
export type PdpRespRecentSales_user$key = {
  readonly " $data"?: PdpRespRecentSales_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespRecentSales_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespRecentSales_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRecentSales_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "438817d040d6f6f8a24cb5363e51f412";

export default node;
